document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-mp-menu-toggle]');
const menu = document.querySelector('[data-mp-mobile-menu]');
if (menuButton && menu) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });
}

const browseButton = document.querySelector('[data-mp-browse-toggle]');
const sidebar = document.querySelector('[data-mp-sidebar]');
if (browseButton && sidebar) {
  browseButton.addEventListener('click', () => {
    const open = browseButton.getAttribute('aria-expanded') === 'true';
    browseButton.setAttribute('aria-expanded', String(!open));
    sidebar.classList.toggle('is-open', !open);
  });
}

document.querySelectorAll('[data-mp-filter]').forEach((button) => {
  button.addEventListener('click', () => {
    const value = button.dataset.mpFilter;
    document.querySelectorAll('[data-mp-product-card]').forEach((card) => {
      const tags = (card.dataset.mpTags || '').toLowerCase();
      card.hidden = value !== 'all' && !tags.includes(value.toLowerCase());
    });
    document.querySelectorAll('[data-mp-filter]').forEach((b) => b.classList.remove('is-active'));
    button.classList.add('is-active');
  });
});

// V5 product gallery + variant selector
(function(){
  function initProductPage(){
    document.querySelectorAll('[data-mp-gallery]').forEach(function(gallery){
      var slides=gallery.querySelectorAll('[data-mp-gallery-slide]');
      var thumbs=gallery.querySelectorAll('[data-mp-gallery-thumb]');
      thumbs.forEach(function(btn){btn.addEventListener('click',function(){
        var idx=btn.getAttribute('data-mp-gallery-thumb');
        slides.forEach(function(s){s.classList.toggle('is-active',s.getAttribute('data-mp-gallery-slide')===idx)});
        thumbs.forEach(function(t){t.classList.toggle('is-active',t===btn)});
      })});
    });
    var variantJson=document.querySelector('[data-mp-product-variants]');
    var variantInput=document.querySelector('[data-mp-variant-id]');
    var optionSelects=document.querySelectorAll('[data-mp-option-index]');
    if(variantJson&&variantInput&&optionSelects.length){
      var variants=[];try{variants=JSON.parse(variantJson.textContent)}catch(e){}
      function updateVariant(){
        var selected=Array.from(optionSelects).map(function(s){return s.value});
        var match=variants.find(function(v){return selected.every(function(val,i){return v.options[i]===val})});
        if(match) variantInput.value=match.id;
      }
      optionSelects.forEach(function(s){s.addEventListener('change',updateVariant)});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initProductPage);else initProductPage();
})();

// V16 global AJAX quick add for homepage, collections, search, and related products
(function(){
  function cartAddUrl(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return root+'cart/add.js';
  }

  document.addEventListener('submit',async function(event){
    var form=event.target.closest('.mp-quick-add-form');
    if(!form)return;

    event.preventDefault();

    var button=form.querySelector('button[type="submit"]');
    if(!button||button.disabled)return;

    var originalText=button.textContent.trim()||'Add to Cart';
    button.disabled=true;
    button.textContent='Adding...';

    try{
      var response=await fetch(cartAddUrl(),{
        method:'POST',
        headers:{'Accept':'application/json'},
        body:new FormData(form)
      });

      if(!response.ok){
        var message='Unable to add product to cart.';
        try{
          var errorData=await response.json();
          if(errorData&&errorData.description)message=errorData.description;
        }catch(parseError){}
        throw new Error(message);
      }

      await response.json();
      button.textContent='Added to Cart ✓';

      document.dispatchEvent(new CustomEvent('micesterpiece:cart-added'));

      window.setTimeout(function(){
        button.disabled=false;
        button.textContent=originalText;
      },1800);
    }catch(error){
      console.error('Micesterpiece quick-add error:',error);
      button.disabled=false;
      button.textContent='Try Again';
      window.setTimeout(function(){
        button.textContent=originalText;
      },1800);
    }
  });
})();

// V14 cart quantity steppers
(function(){
  async function updateCartItem(key, quantity){
    try{
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var response=await fetch(root+'cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity:quantity})
      });
      if(!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    }catch(error){
      var form=document.getElementById('MpCartForm');
      if(form) form.submit();
    }
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-mp-cart-increase],[data-mp-cart-decrease]');
    if(!button)return;
    var item=button.closest('[data-mp-cart-item]');
    var input=item&&item.querySelector('[data-mp-cart-input]');
    if(!item||!input)return;
    var current=parseInt(input.value||'0',10);
    var next=button.hasAttribute('data-mp-cart-increase')?current+1:Math.max(0,current-1);
    input.value=next;
    updateCartItem(item.dataset.key,next);
  });
  document.addEventListener('change',function(event){
    var input=event.target.closest('[data-mp-cart-input]');
    if(!input)return;
    var item=input.closest('[data-mp-cart-item]');
    if(!item)return;
    var quantity=Math.max(0,parseInt(input.value||'0',10));
    input.value=quantity;
    updateCartItem(item.dataset.key,quantity);
  });
})();
